import { render, staticRenderFns } from "./Wound.vue?vue&type=template&id=9fdbbbbc"
import script from "./Wound.vue?vue&type=script&lang=ts"
export * from "./Wound.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports